<template>
    <!-- `https://www.difarmer.com/imagenes/PopUpWeb/${popup[0].id}` + this.imgExtension() -->
    
    <div v-if="popupListo">
        <div class="popup" v-if="!cerrar" @click="cerrar=true" :key="popupKey">        
            <div class="popup-content m-1 m-md-0" @click.stop="">   
                <div class="d-flex justify-content-end">
                    <button class="popup-close" @click="cerrar = true">
                        <i class="fa fa-times"></i>
                    </button>         
                </div>      

                <img :class="this.popup[0].urlArticulo != '' ? 'cursor-pointer' : ''" 
                    class="img-fluid" 
                    :src="imagenOptima(this.popup[0].id)"
                    @click="moverUrl(popup[0])"/>
            </div>        
        </div>   
    </div> 
</template>

<script>
import axios from 'axios'
import servicio from "@/services/servicio-inicio"
export default {
    data(){
        return {
            popup:[],
            banner: 'https://www.difarmer.com/include/img/popup/banner.jpg?uuid=' + this.$uuid.v4(),
            imagenPopup: '',
            cerrar: false,
            codCliente: 0,
            CadenaRelacionados: '',
            TienesRelacionados:  false,
            popupKey: 0,
            popupListo: false
        }
    },
    created(){
        this.popupListo = false
    },
    mounted(){
        let token = JSON.parse(window.localStorage.tokenDifarmer);
        let user = JSON.parse(token.user);
        this.codCliente = user.codCliente;
        //console.log(this.$uuid)
        //this.$bvModal.show("popup-modal")
        //this.checarBanner()
        
        this.obtenerPopUp()
    },
    methods:{
        cerrarPopUp(){

        },
        checarBanner() {
            axios.get("https://www.difarmer.com/servicio/parametros/webpopup")
            .then(r => {                
                console.log(r.data.value)                
                if (r.data.value == "true") {   
                    this.$bvModal.show("popup-modal")
                    this.banner = 'https://www.difarmer.com/include/img/popup/banner.jpg?uuid=' + this.$uuid.v4()
                }                
            })
            .catch(err => {
                console.log(err)
            })
        },
        async moverUrl(item) {

            console.log("item", item)
            await this.registrarClickPublicidad(item)

            await this.obtenerArticulosRelacionados(item)

            if (this.TienesRelacionados && this.CadenaRelacionados.length > 0){

                var cadenaSinCorchetes = this.CadenaRelacionados.replace(/\[|\]/g, '');
                var valores = cadenaSinCorchetes.split(',');
                if (valores.length > 1) {
                    this.$root.$emit('Layout-Buscar',  { buscar: this.CadenaRelacionados, pagina: 1, busquedaAvanzada: false } )
                }else{
                    if (item.urlArticulo != '') {
                        location.href = item.urlArticulo;
                    }
                }
            }
            else
            {
                //Si no tiene relacionados abre el url del articulo
                if(item.urlArticulo != ''){ 
                    location.href = item.urlArticulo
                }
            }
        },
        obtenerPopUp(){
            servicio.obtenerPopUp(this.codCliente)
                .then( r => {
                    //console.log('obtenerpopup', r.data)
                    if(r.data.length > 0){
                        //console.log('DATA', r.data[0].id)
                        //this.imagenPopup = 'https://www.difarmer.com/imagenes/PopUpWeb/' + r.data[0].id + '.jpg';
                        this.popup = r.data
                        this.popupKey++
                        this.popupListo = true

                        this.$bvModal.show("popup-modal")
                    }
                })
                .catch( error => {
                    console.log('obtenerPupUp', error)
                })
        },
        imagenOptima(item){
            return 'https://www.difarmer.com/imagenes/PopUpWeb/' + item + this.imgExtension()
        },
        async registrarClickPublicidad(item){

            var jsonObject = JSON.parse(window.localStorage.tokenDifarmer);
            var token = jsonObject.token;

            let r = await servicio.registrarClickPublicidad({
                IdPublicidad: item.id,
                TipoPublicidad: "P",
                CodCliente: this.codCliente,
                AccessToken: token
            })
            if (r.value){
                console.log("Se registro click publicidad")
            }
        },
        async obtenerArticulosRelacionados(item){
				this.TienesRelacionados = false
				this.CadenaRelacionados = ""

				let r = await servicio.obtenerArticulosRelacionados(item.id,"P")
				
				if (r.value){
					this.CadenaRelacionados = r.data[0]
					this.TienesRelacionados = true
				}
        },
    }
}
</script>

<style lang="scss" scoped>
.popup{
    position: fixed;  
    top:0;
    left: 0;
    height: 100vh;
    width: 100vw;
    display: flex;
    z-index: 1080;
    background: rgba($color: #000000, $alpha: 0.7);
    justify-content: center;
    align-items: center;    

    .popup-content{  
        background: #fff;      
        padding: 0em 1.3em 1.3em 1.3em;
        border: 1px solid #eee;
        border-radius: 15px;
        position: absolute;                

        .popup-close{
            border: 1px solid #fff;
            border-radius: 50%;
            width: 2.5em;
            height: 2.5em;
            position: relative;             
            right: -1.3em;            
            background: transparent;

            &:hover{
                color:#F00;
            }

        }
    }
    
}


.modal-header {
    padding: 0 1rem;
}
/* .modal-header .close {
    padding: 1rem 1rem 0rem 0rem;    
} */

.modal-body {
    padding: 0rem;
}

.overlay {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    transition: opacity 500ms;
    visibility: hidden;
    opacity: 0;
    z-index:1100;
    display:flex;
    align-items:flex-start
}
.overlay:target {
    visibility: visible;
    opacity: 1;
}
#popupBody{
    max-width: 95%;            
    padding: 2%;
    border-radius: 15px;
    box-shadow: 0 0 5px #CCC;
    background: #FFF;
    position: relative;
    transition: all 5s ease-in-out;
    /*margin: 20% auto;*/
    margin: 5px auto;
    z-index:1100;
}
#cerrar{
    position: absolute;
    top: 0px;
    right: 30px;
    transition: all 200ms;
    font-size: 30px;
    font-weight: bold;
    text-decoration: none;
    color: #F00;            
}
.popupContent img{
    max-width:100%;
}
</style>